module.exports = __webpack_public_path__ + "assets/img/01.beee7eaa.png";